<div
  class="avatar"
  [ngClass]="theme === 'THEME-1' ? 'theme-1' : 'theme-2'"
  [class]="sizeClass"
  role="img"
  [attr.aria-label]="'Avatar of ' + userName">
  {{ initials }}
</div>
